import { DesignComponentOrigin } from "../support/SDKDesignComponentOrigin";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DesignComponentBase {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, sources) {
        var _a, _b, _c;
        this.id = model.persistentId;
        this.brandId = model.brandId;
        this.thumbnailUrl = (_a = model.thumbnailUrl) !== null && _a !== void 0 ? _a : null;
        this.svgUrl = (_b = model.svgUrl) !== null && _b !== void 0 ? _b : null;
        this.name = model.meta.name;
        this.description = (_c = model.meta.description) !== null && _c !== void 0 ? _c : null;
        // this.componentPropertyDefinitions = model.componentPropertyDefinitions
        //   ? resolveComponentPropertyDefinition(model.componentPropertyDefinitions)
        //   : null
        // this.variantPropertyValues = model.variantPropertyValues ?? null
        // this.childrenPersistentIds = model.childrenPersistentIds ?? null
        // this.parentComponentPersistentId = model.parentComponentPersistentId ?? null
        // @ts-expect-error TS(2345): Argument of type 'DesignComponentOriginModel | und... Remove this comment to see the full error message
        this.origin = new DesignComponentOrigin(model.originComponent, sources);
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
    }
}
